import React, {Component} from 'react';

import SortUp from './sort-amount-up-light.svg.js';
import CheckCircle from './check-circle-solid.svg.js';

const HIDDEN = 'Hidden';

const AVAILABILITY = {
    'A' : 'The indicator is being produced',
    'B' : 'The indicator is not produced but it could be produced using existing data sources',
    'C' : 'The indicator is not being produced and could not be generated from existing data sources',
    'C & C1': 'The indicator is not being produced and could not be generated from existing data sources. Some data is available but further refinement and complementary information is required to produce the indicator',
    'C & C2': 'The indicator is not being produced and could not be generated from existing data sources. Data are not available to produce the indicator',
    'NA': 'Not applicable for Aruba'
};

const TIER_DESCRIPTION = {
    '1': 'Tier I Indicator is conceptually clear, has an internationally established methodology and standards are available, and data are regularly produced by countries for at least 50 per cent of countries and of the population in every region where the indicator is relevant.',
    '2': 'Tier II Indicator is conceptually clear, has an internationally established methodology and standards are available, but data are not regularly produced by countries.',
    '3': 'Tier III No internationally established methodology or standards are yet available for the indicator, but methodology/standards are being (or will be) developed or tested.'
};

export default class Indicator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            indicatorDescriptionTooltipState: HIDDEN,
            targetDescriptionTooltipState: HIDDEN,
        };
    }

    onClickMoreInfo = (event) => {
        let { moreInfoURL, onOpenURL } = this.props;
        if (onOpenURL) {
            onOpenURL(moreInfoURL);
        }
        event.preventDefault();
    }

    render() {
        let {
            availabilityClassification,
            number,
            detailColor,
            lastMeasuredValue,
            lastMeasuredYear,
            title,
            moreInfoURL,
            shortTitle,
            target,
            tierClassification,
        } = this.props;
        return (
            <div className="Indicator">
                <div className={`IndicatorHeader ${lastMeasuredValue ? '' : 'Disabled'}`} />
                <div className="IndicatorDescriptionContainer">
                    <span className="Title" data-tooltip={title}
                        style={{color: detailColor}}
                    >
                        Indicator {number}:
                    </span>
                    <span className="ShortDescription">{shortTitle}</span>
                </div>
                <div className="LastMeasuredValueContainer">
                    <span className="MeasuredValue">{lastMeasuredValue ? lastMeasuredValue : 'N/A'}</span>
                    <span className="MeasuredYear">Measured in {lastMeasuredYear}</span>
                </div>
                <div className="TargetDescriptionContainer">
                    <span className="Title" data-tooltip={target.title}
                        style={{color: detailColor}}
                    >
                        Target {target.number}:
                    </span>
                    <span className="ShortDescription">{target.shortTitle}</span>
                </div>
                <div className="GroupingInformationContainer">
                    <div className="UNTierInformationContainer">
                        <SortUp 
                            className="Image" 
                            style={{fill: detailColor}}
                        />
                        <span 
                            className="Title" data-tooltip={TIER_DESCRIPTION[tierClassification]}
                            style={{color: detailColor}}
                        >
                            UN Tier:
                        </span>
                        <span 
                            className="Description"
                            style={{color: detailColor}}
                        >
                            {tierClassification}
                        </span>
                    </div>
                    <div 
                        className="AvailabilityInformationContainer"  
                        data-tooltip={AVAILABILITY[availabilityClassification]}
                    >
                        <CheckCircle 
                            className="Image" 
                            style={{fill: detailColor}}
                        />
                        <span 
                            className="Title"
                            style={{color: detailColor}}
                        >
                            Availability:
                        </span>
                        <span 
                            className="Description"
                            style={{color: detailColor}}
                        >
                            {availabilityClassification}
                        </span>
                    </div>
                </div>
                <div 
                    className="Footer"
                    style={{
                        backgroundColor: detailColor
                    }}
                >
                    <button title={moreInfoURL} onClick={this.onClickMoreInfo}>More Info</button>
                </div>
            </div>
        );
    }
}